// extracted by mini-css-extract-plugin
export default {"wrapper":"Advt_wrapper__oI-I-","titleBlock":"Advt_titleBlock__3Vb0B","title":"Advt_title__Zh4yi","qrsWrapper":"Advt_qrsWrapper__J9-4u","qrCode":"Advt_qrCode__dpSm5"};